export const LOCKING_DISTRUCTION = {
    title: '中国大地财产保险股份有限公司',
    subtitle: '家庭财产保险<br>附加门窗锁恶意破坏保险条款',
    register_number: '（注册号：C00001032122018073010832）',
    protocols: [
        {
            intro: '保险责任',
            list: [
                {
                    order: '第一条',
                    context: '在保险期间内，主险保险单载明地址的房屋（以下简称“被保险房屋”）的门、窗、锁,由于在遭受经公安部门确认的外部人员的入室盗窃、抢劫（以下简称“盗抢”）过程中被破坏而导致的自身损失，保险人按照本附加险合同的约定负责赔偿。'
                }
            ]
        },
        {
            intro: '责任免除',
            list: [
                {
                    order: '第二条',
                    context: '下列任何原因造成的损失、费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）投保人、被保险人及其代表的故意行为、重大过失行为；' },
                        { text: '（二）被保险人的家庭成员、家政服务人员、暂居人员盗抢或纵容他人盗抢。' }
                    ]
                },
                {
                    order: '第三条',
                    context: '下列损失、费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）被保险房屋无人居住或无人看管超过六十天的情况下遭受的盗窃损失；' },
                        { text: '（二）保险单载明的免赔额或按照保险单载明的免赔率计算的免赔额；' },
                        { text: '（三）其他不属于本保险责任范围内的损失、费用。' }
                    ]
                }
            ]
        },
        {
            intro: '保险金额和免赔额（率）',
            list: [
                { order: '第四条', context: '保险金额由投保人与保险人双方协商确定，并在保险单中载明。' },
                { order: '第五条', context: '每次事故免赔额（率）由投保人与保险人在签订本附加险合同时协商确定，并在保险单中载明。' }
            ]
        },
        {
            intro: '赔偿处理',
            list: [
                { order: '第六条', context: '发生保险责任范围内的损失时，保险人按照实际损失在扣除每次事故免赔额或按照保险单载明的每次事故免赔率计算的免赔额后进行赔偿。' },
                { order: '第七条', context: '在保险期间内，保险人在本附加险合同下承担的赔偿金额累计不超过保险单载明的保险金额。' }
            ]
        },
        {
            intro: '其他事项',
            list: [ { order: '第八条', context: '本附加险条款未尽事宜，以主险条款的约定为准；本附加险条款与主险条款若有相抵触之处，以本附加险条款的约定为准。' } ]
        }
    ]
}